import Container from '@/components/atoms/Container'
import { Onboarding } from './Onboarding'
import { Classes } from './Classes'

export function HomeCourseList() {
	return (
		<Container className='flex flex-col px-0 pt-12 gap-6'>
			<Onboarding />

			<Classes />
		</Container>
	)
}
